import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 625.28",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #fff;\n      }\n    " }) }), /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M714.41,117.08l-26.71-27.86c-10.29-10.56-27.31-10.8-39.07.53l-304.45,336.37-194.11-184.48c-10.06-9.79-27.68-9.39-37.3.69l-27.36,28.67c-10.02,10.41-9.71,27.06.83,37.21l240.25,228.49c5.03,4.84,11.42,7.3,17.94,7.3,6.85,0,13.87-2.73,19.57-8.31l349.71-380.63c10.66-10.33,10.95-27.42.71-37.99Z"
	})]
});
export default SvgCheckWhite;
